import { SuggestionSearchBar } from '@aibees/elephant/feature/suggestion-search-bar';
import { useAutoSuggestedPeople } from '@aibees/elephant/hooks/people/use-auto-suggested-people';
import { sanitizeLinkedinUrl } from '@aibees/elephant/utils/url';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { useDefaultValues } from '../company-similarity-search/hooks/use-default-values';
import { HomePeopleAnalysis } from '../home-people-analysis';
import * as Styled from './styles';
import * as SX from './sx';
import type { HomeAnalysisSearchProps as Props } from './types';

// TODO @Mohammad79-nkv please check the error eslint-disable-next-line react-hooks/rules-of-hooks

export const HomeAnalysisSearch = memo(({ className }: Props) => {
  const defaultValues = useDefaultValues();
  return (
    <Styled.Wrapper
      className={classnames('HomeAnalysisSearch', className)}
      sx={SX.root}
    >
      <SuggestionSearchBar
        multiple
        limit={5}
        renderMode="dialog"
        searchCategory="people"
        fetchOptions={(searchValue: string) =>
          // eslint-disable-next-line react-hooks/rules-of-hooks
          useAutoSuggestedPeople(sanitizeLinkedinUrl(searchValue))
        }
        defaultValue={defaultValues}
        searchIcon="linkedin-contain"
        placeholder="Enter Name or Paste the LinkedIn URL here"
        detailActionElement={({ id }) => <HomePeopleAnalysis id={id} />} // TODO detail action element
      />
    </Styled.Wrapper>
  );
});

HomeAnalysisSearch.displayName = 'HomeAnalysisSearch';
